// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableContainer .auditInnerContainer {
  background-color: #f5f7f9;
  padding: 10px 10px;
  margin: 10px 0px 10px 0px;
  border-radius: 6px;
  font-family: Arial;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.25;
  letter-spacing: normal;
  text-align: left;
  /* width: 22rem; */
  height: auto;
  /* margin: 10px; */
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
}
.tableContainer .auditSection {
  margin-top: 10px;
  margin-bottom: 10px;
}
.tableContainer .mbAudit {
  margin-bottom: 10px !important;
}
.tableContainer .reportingAuditFormSection {
  border: 1px solid #9e9fa1;
}
.tableContainer .reportingAuditFormSection input::-webkit-outer-spin-button,
.tableContainer .reportingAuditFormSection input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.tableContainer .reportingHeader p {
  font-weight: bold;
}
.tableContainer .reportinInputSection {
  display: flex;
}
.tableContainer .reportinInputSection input {
  width: 80%;
  padding: 10px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/pages/AuditModules/AuditDetails/AuditDetails.scss"],"names":[],"mappings":"AA+BE;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;AA9BJ;AAgCE;EACE,gBAAA;EACA,mBAAA;AA9BJ;AAgCE;EACE,8BAAA;AA9BJ;AAiCE;EACE,yBAAA;AA/BJ;AAgCI;;EAEE,wBAAA;EACA,SAAA;AA9BN;AAmCI;EACE,iBAAA;AAjCN;AAqCE;EACE,aAAA;AAnCJ;AAoCI;EACE,UAAA;EACA,aAAA;EACA,YAAA;AAlCN","sourcesContent":["// .auditAccordion {\n//   margin-bottom: 24px;\n//   .card {\n//     position: relative;\n//     display: flex;\n//     flex-direction: column;\n//     min-width: 0;\n//     word-wrap: break-word;\n//     background-color: #fff;\n//     background-clip: border-box;\n//     /* border: 1px solid rgba(0, 0, 0, 0.125); */\n//     border-radius: 0.25rem;\n//     display: block;\n//     border-top: 5px solid #969696;\n//     /* font-size: 16px; */\n//     color: #000000;\n//     margin-bottom: 13px;\n//     /* clear: both; */\n//     position: relative;\n//     border: 2px solid #ddd;\n//     /* border-radius: 8px; */\n//     box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);\n//     /* background-color: #fff; */\n//     /* width: 50vh; */\n//     /* height: 11vh; */\n//     position: relative;\n//   }\n\n// }\n\n.tableContainer {\n  .auditInnerContainer {\n    background-color: #f5f7f9;\n    padding: 10px 10px;\n    margin: 10px 0px 10px 0px;\n    border-radius: 6px;\n    font-family: Arial;\n    font-size: 16px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2.25;\n    letter-spacing: normal;\n    text-align: left;\n    /* width: 22rem; */\n    height: auto;\n    /* margin: 10px; */\n    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);\n  }\n  .auditSection {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n  .mbAudit {\n    margin-bottom: 10px !important;\n  }\n\n  .reportingAuditFormSection {\n    border: 1px solid #9e9fa1;\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  }\n\n  .reportingHeader {\n    p {\n      font-weight: bold;\n    }\n  }\n\n  .reportinInputSection {\n    display: flex;\n    input {\n      width: 80%;\n      padding: 10px;\n      height: 40px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
